/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

/* React Boostrap */
import Footer from "../components/main/Footer"

/* Components */
import { Topbar } from "../components/organisms/Topbar"
import { initPdiComponent } from "../core/service/BusinessLogicService"

/* Utils */
import { isPdiRetailTenant, loc } from "../core/utils"
import React, { useEffect } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"

export default function MaintenancePage({ tunnelData, history }) {
  useEffect(() => {
    initPdiComponent("MaintenancePage")
  }, [])

  return (
    <Container fluid>
      <Row noGutters>
        <Col className="misc-block">
          <Row>
            <Topbar tunnelData={tunnelData} displayToggleButton={false} history={history} />

            <Col sm={12}>
              {/* CONTENT */}
              <Container>
                <Row className="justify-content-center">
                  <Col xs={11} sm={10} md={7} lg={5} className="hard-shadow-white-block text-center misc-mono-block">
                    <span className="ico-danger-background">
                      <i className="fas fa-cog"></i>
                    </span>
                    <h1>{loc`Maintenance`}</h1>
                    <p>{loc`The app is temporarily unavailable.`}</p>
                    <p>{loc`Please come back later.`}</p>
                    <Button
                      href={
                        isPdiRetailTenant(tunnelData?.tenant) ? `${tunnelData?.pdiRetailUrl}home` : tunnelData?.shopUrl
                      }
                      variant="primary"
                      className="ico-back-small-before"
                    >
                      {loc`Back to shop`}
                    </Button>
                  </Col>
                </Row>
              </Container>
              {/* END CONTENT */}
            </Col>
            <Col sm={12}>
              <Container>
                <Footer tunnelData={tunnelData} />
              </Container>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}
